import React from 'react';
import {Icon as IconComp} from './styles';
import RequestIcon from '../../../assets/icons/remittance.svg';

interface Props {
  size?: number;
  src: string;
  className?: any;
}

const Icon: React.FC<Props> = ({size, src = RequestIcon, className}) => {
  return <IconComp src={src} size={size} className={className} />;
};

export default Icon;
